module.exports = __webpack_public_path__ + "static/img/ldgwdgc.510102e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/ldgwdgc.jpg
// module id = G5wS
// module chunks = 2